import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const professionService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching profession list", error);
            throw error;
        }
    },

    async findByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/profession/findByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByUuid profession", error);
            throw error;
        }
    },

    async save(profession: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession/save`,
                profession
            );
            return response.data;
        } catch (error) {
            console.error("Error save profession", error);
            throw error;
        }
    },

    async uploadTemplate(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/profession/upload-template`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save profession", error);
            throw error;
        }
    },

    async deleteByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/profession/deleteByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteByUuid profession", error);
            throw error;
        }
    },
}

export default professionService;
